<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class InquiryContent extends Vue {
  @Prop({ type: String }) value;
  @Prop(Boolean) showCustomers;
  @Prop({ type: String }) date;

  customers = [];
  fetchingCustomers = false;
  fetchingCustomersRequest = null;

  @Watch('date', { immediate: true })
  onDateChange() {
    if (this.showCustomers) {
      this.fetchCustomers();
    }
  }

  get input() {
    return this.value;
  }

  set input(val) {
    this.$emit('change', val);
  }

  beforeDestroy() {
    this.cancelFetchCustomersRequest();
  }

  cancelFetchCustomersRequest() {
    if (this.fetchingCustomersRequest && this.fetchingCustomersRequest.engine) {
      this.fetchingCustomersRequest.engine.abort();
    }
  }

  async fetchCustomers() {
    this.cancelFetchCustomersRequest();
    if (!this.date) {
      this.customers = [];
      return;
    }

    this.fetchingCustomers = true;
    try {
      const $now = moment(this.date);
      this.fetchingCustomersRequest = this.$request.get('/customers', {
        params: {
          related_between: [
            $now.clone().startOf('day').toISOString(),
            $now.clone().endOf('day').toISOString(),
          ],
          page: 1,
          per_page: 99,
        },
      }, { loading: false });
      const { data } = await this.fetchingCustomersRequest;
      this.customers = data;
    } finally {
      this.fetchingCustomers = false;
    }
  }

  async fillCustomers() {
    this.input = `${this.input ? this.input + '\n' : ''}` + this.customers.map(customer => `${customer.name}: `).join('\n');
  }
}
</script>

<template>
  <div class="inquiry-content">
    <el-card class="box-card" header="今日新客" shadow="never" size="small" v-if="date && showCustomers" v-loading="fetchingCustomers">
      <template v-if="customers.length">
        <div class="box-customers">
          <el-tag v-for="customer in customers" :key="customer.id">{{ customer.name }}</el-tag>
        </div>
        <div class="action">
          <el-button type="primary" size="mini" @click="fillCustomers">填入新客</el-button>
        </div>
      </template>
      <div v-else>
        /
      </div>
    </el-card>
    <el-input type="textarea" v-model="input" rows="10"></el-input>
  </div>
</template>

<style lang="scss" scoped>
.box-card {
  margin-bottom: 10px;

  /deep/ .el-card__header {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .action {
    margin-top: 10px;
  }
}

.box-customers {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
